// UFG-67
import { productLinesStyles } from "@insite/content-library/Widgets/BrandDetails/BrandDetailsProductLines";
import { css } from "styled-components";

productLinesStyles.productLineImage = {
    css: css`
    img {
        height: auto;
        border: 1px red;
    }
`,
}
productLinesStyles.productLineImageItem =  {
    width: 12,
    align: "middle",
    css: css`
        width: 100%;
        height: auto;
        justify-content: center;
    `,
}